import {Injectable} from '@angular/core';
import {NestApiProvider} from '../../nest-api';
import {Observable} from 'rxjs';
import {
  Paging,
  RequestAddDto,
  RequestDeleteDto,
  RequestFilterDto,
  RequestFilterEmployeeDto,
  RequestSaveDto,
  ResponseAddDto,
  ResponseFilterDto,
  ResponseFilterEmployeeDto,
  ResponseGetListingDto,
  ResponseSaveDto,
} from '../dto/sf-mass-leave.dto';
import {ResponseData, ResponsePaging} from '../../nest-responses';

@Injectable()
export class SfMassLeaveApi {

  private service: string = '';
  private model: string = 'sfMassLeave';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getListing(limit: string | number, page: string | number): Observable<ResponseGetListingDto> {
    const method: string = 'POST';
    const func: string = 'getListing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetListingDto>(method, url, params, urlParams, body);
  }

  public filterEmployee(limit: string | number, page: string | number, payload: RequestFilterEmployeeDto): Observable<ResponseFilterEmployeeDto> {
    const method: string = 'POST';
    const func: string = 'filterEmployee';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFilterEmployeeDto>(method, url, params, urlParams, body);
  }

  public save(payload: RequestSaveDto): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public delete(payload: RequestDeleteDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public filterMemberAvailable(payload: RequestFilterDto, paging: Paging): Observable<ResponsePaging<ResponseFilterDto>> {
    const method: string = 'POST';
    const func: string = 'filterMemberAvailable';
    const params: any = payload || {};
    const urlParams: any = paging || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseFilterDto>>(method, url, params, urlParams, body);
  }

  public filterMemberList(payload: RequestFilterDto): Observable<ResponsePaging<ResponseFilterDto>> {
    const method: string = 'POST';
    const func: string = 'filterMemberList';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseFilterDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-mass-leave.api.ts